import isEqualWith from 'lodash.isequalwith'
import {
  isArray,
  isDef,
  isEmpty,
  isValidDate,
  isValue,
} from './validator'
import { dayjs } from './date'

export function isLooseEqual (var1, var2) {
  return isEqualWith(var1, var2, (a, b) => {
    if ((!isValue(a) || isEmpty(a)) && (!isValue(b) || isEmpty(b))) {
      return true
    }

    if (isValidDate(a) && isValidDate(b) && (dayjs(a).valueOf() === dayjs(b).valueOf())) {
      return true
    }
  })
}

export function last (array = []) {
  return isArray(array)
    ? array[array.length - 1]
    : undefined
}

export function chunk (array = [], size = 0) {
  if (!size) {
    return array
  }

  return Array.from({ length: Math.ceil(array.length / size) }, (v, i) => {
    return array.slice(i * size, i * size + size)
  })
}

export function renameKey (obj = {}, oldKey = '', newKey = '') {
  if (oldKey === newKey) {
    return
  }

  obj[newKey] = obj[oldKey]

  delete obj[oldKey]

  return obj
}

export function deleteKey (obj = {}, key = '') {
  const value = obj[key]

  delete obj[key]

  return value
}

export function dig (obj = {}, path = '', value) {
  const array = path
    .replace(/\[([^[]]*)\]/g, '.$1.')
    .split('.')
    .filter((t) => t)

  return array.reduce((prev, cur, index) => {
    if (array.length - 1 === index && isDef(value)) {
      prev[cur] = value
    }

    return prev && prev[cur]
  }, obj)
}

export merge from 'lodash.merge'

export uniq from 'lodash.uniq'

export uniqBy from 'lodash.uniqby'

export cloneDeep from 'lodash.clonedeep'

export omit from 'lodash.omit'

export omitBy from 'lodash.omitby'

export pick from 'lodash.pick'

export pickBy from 'lodash.pickby'

export groupBy from 'lodash.groupby'

export keyBy from 'lodash.keyby'

export isEqual from 'lodash.isequal'

export sortBy from 'lodash.sortby'

export remove from 'lodash.remove'

export differenceBy from 'lodash.differenceby'

export pullAllBy from 'lodash.pullallby'

export intersectionBy from 'lodash.intersectionby'

export intersection from 'lodash.intersection'

export takeRightWhile from 'lodash.takerightwhile'

export findLastIndex from 'lodash.findlastindex'

export isEqualWith from 'lodash.isequalwith'
